import { Component, ChangeDetectorRef, HostListener, OnInit, ViewChild } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { routes } from './pages/app-routing.module';
import { AppService } from './security/service/app.service';
import { AuthGuard } from './security/guards/auth-guard/auth.guard';
import { SignatureService } from './security/signature/signature.service';
import { PrimeNGConfig } from 'primeng/api';
import { AtualizacoesService } from './pages/atualizacao/atualizacoes.service';
import { ComunicadoService } from './pages/comunicado/service/comunicado.service';
import { Subscription, interval } from 'rxjs';
import { take, filter } from 'rxjs/operators';
import { NavegacaoComponent } from './pages/navegacao/navegacao.component';

declare var $: any;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {

  notificacao = true;
  logado = false;
  getUser: any;

  resolucaoTelaGrafico = screen.availWidth;

  redimensionou: boolean;
  menu: boolean;
  resolucao: boolean;
  itensMenu = [];
  language: any;
  conversao = null;
  _exibirMenu = false;
  badgeValue: number = null;
  private intervalId: any;
  private intervalIdNotificacao: any;
  displayBasic2: boolean = false;
  contador: any;
  dadosTranslate = [];
  dadosCache = [];
  breadcrumbs = [];
  private inactivitySubscription: Subscription;
  private inactivityContador: Subscription;
  private routerSubscription: Subscription;
  private notificacaoSubscription: Subscription;
  temNotificacaoComunicado = false;
  private tokenExpirationTime: number;

  @ViewChild(NavegacaoComponent) navegacaoComponent!: NavegacaoComponent

  constructor(
    private cdRef: ChangeDetectorRef,
    private service: AppService,
    private auth: AuthGuard,
    private config: PrimeNGConfig,
    private translateService: TranslateService,
    private serviceAtualizacao: AtualizacoesService,
    private serviceComunicado: ComunicadoService,
    private router: Router,
    private signatureService: SignatureService) {

    routes.map(item => {
      if (item.data !== undefined) {
        this.breadcrumbs.push(item.data);
      }
    });

    translateService.addLangs(['br', 'gb']);
    translateService.setDefaultLang('br');

    const browserLang = translateService.getBrowserLang();

    this.conversao = JSON.parse(sessionStorage.getItem('language'));

    if (this.conversao == null) {
      sessionStorage.setItem('language', JSON.stringify(browserLang.match(/br|gb/) ? browserLang : 'br'));
      translateService.use(browserLang.match(/br|gb/) ? browserLang : 'br');
    } else {
      translateService.use(this.conversao);
    }

  }

  ngOnInit() {

    // Renova o tempo do servidor ao carregar/recarregar a página para evitar "requisição expirada"
    this.signatureService.sync().subscribe();

    this.intervalId = setInterval(() => {
      this.requisicao();
    }, 6000000);

    // Inscrever-se no Observable de notificação do serviço
    // Isso permite que o badge seja atualizado automaticamente quando
    // o usuário ler/marcar comunicados
    this.notificacaoSubscription = this.serviceComunicado.notificacao$.subscribe(
      temNotificacao => {
        this.temNotificacaoComunicado = temNotificacao;
        // Forçar detecção de mudanças para atualizar a view imediatamente
        this.cdRef.detectChanges();
      }
    );

    // Verificar notificações a cada 10 minutos (600000 ms)
    this.intervalIdNotificacao = setInterval(() => {
      this.verificarNotificacaoComunicado();
    }, 600000);

    // Verificar notificações quando mudar de página/rota
    this.routerSubscription = this.router.events
      .pipe(
        filter(event => event instanceof NavigationEnd)
      )
      .subscribe((event: NavigationEnd) => {
        // Se navegar para o login, garante que o modal de aviso e o contador de inatividade parem
        if (event.url.includes('login')) {
          this.displayBasic2 = false;
          if (this.inactivityContador) {
            this.inactivityContador.unsubscribe();
          }
        }
        // Renova o tempo do servidor a cada navegação (clique no menu) para evitar requisição expirada
        this.signatureService.sync().subscribe();
        this.resetInactivityTimer();
        this.verificarNotificacaoComunicado();
      });

    this.config.setTranslation({
      dayNames: ['Domingo', 'Segunda', 'Terça', 'Quarta', 'Quinta', 'Sexta', 'Sábado'],
      dayNamesShort: ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sab'],
      dayNamesMin: ['Do', 'Se', 'Te', 'Qu', 'Qu', 'Se', 'Sa'],
      monthNames: ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho',
        'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'],
      monthNamesShort: ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'],
      today: 'Hoje',
      clear: 'Limpar'
    });

    if (this.resolucaoTelaGrafico > 1001) {
      this.menu = true;
      this.redimensionou = true;
      this.resolucao = true;
    } else {
      this.menu = false;
      this.redimensionou = false;
      this.resolucao = false;
    }
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.resolucaoTelaGrafico = event.target.innerWidth;
    if (this.resolucaoTelaGrafico > 1001) {
      this.redimensionou = true;
      this.alterouResolucao();
    } else {
      this.redimensionou = false;
      this.alterouResolucao();
    }
  }

  @HostListener('window:mousemove')
  @HostListener('window:keydown')
  @HostListener('window:click')
  resetInactivityTimer() {
    if (this.logado) {
      this.tokenExpirationTime = Date.now() + 30 * 60 * 1000;
    }
  }

  alterouResolucao(): void {
    if (this.resolucao) {
      this.menu = !this.menu;
    }
  }

  get habilitar(): boolean {
    const userRole = JSON.parse(sessionStorage.getItem('currentUser')).username;
    if (userRole === "admin") {
      return true;
    } else {
      return false;
    }
  }

  get tratarLogado(): boolean {
    const logado = this.auth.getLogado();
    const getUser = this.auth.getUsername();

    this.getUser = getUser;

    if (logado !== this.logado) {
      this.logado = logado;
      this.cdRef.detectChanges();

      if (this.inactivitySubscription) {
        this.inactivitySubscription.unsubscribe();
      }

      if (this.logado) {

        this.contagemToken();
        this.service.getMenu()
          .then(res => {
            this.itensMenu = res.menu;
            this._exibirMenu = this.itensMenu.length > 2;
          })
          .catch(erro => console.error(erro));
      }

    }

    return this.logado, this.getUser;
  }

  toogleMenu() {
    if (this.navegacaoComponent) {
      this.navegacaoComponent.toggleSidebar();
    }
    this.menu = !this.menu;
  }

  desativaNotificacao() {
    if (this.notificacao === false) {
      $('#notificacao').toggleClass('active');
    }
  }

  toogleNotificacao() {
    $('#notificacao').toggleClass('active');
  }

  switchLanguage(language: string) {
    this.language = language;
    this.translateService.use(this.language);
    this.translateService.get('primeng').subscribe(res => this.config.setTranslation(res));
  }

  onSidebarToggle(isActive: boolean) {
    // Atualizar o estado do menu quando o sidebar for toggled
    this.menu = isActive;
  }

  requisicao() {
    this.serviceAtualizacao.agendamento().subscribe(res => {
      if (res[0] != undefined) {
        this.badgeValue = res[0].qtd_versao_disponivel;
      } else {
        this.badgeValue = null
      }
    });
  }

  verificarNotificacaoComunicado() {
    if (this.logado) {
      this.serviceComunicado.verificarNotificacao()
        .then(res => {
          this.temNotificacaoComunicado = res.temNotificacao || false;
        })
        .catch(erro => {
          console.error('Erro ao verificar notificação de comunicado:', erro);
        });
    }
  }

  ngOnDestroy() {
    clearInterval(this.intervalId);
    clearInterval(this.intervalIdNotificacao);
    
    if (this.routerSubscription) {
      this.routerSubscription.unsubscribe();
    }
    
    if (this.notificacaoSubscription) {
      this.notificacaoSubscription.unsubscribe();
    }
    
    if (this.inactivitySubscription) {
      this.inactivitySubscription.unsubscribe();
    }
  }

  private logoutUser() {
    this.displayBasic2 = true;
    this.inactivityContador = interval(1000).pipe(take(60)).subscribe(
      value => {
        this.contador = 59 - value
        if (this.contador == 0) {
          this.retornoLogin();
          if (this.inactivitySubscription) {
            this.inactivitySubscription.unsubscribe();
          }
        }
      }
    )
  }

  getToken() {
    this.displayBasic2 = false;
    this.navegacaoComponent.getNavegacao();
    this.contagemToken();
    if (this.inactivityContador) {
      this.inactivityContador.unsubscribe();
    }
  }

  retornoLogin() {
    sessionStorage.clear();
    this.displayBasic2 = false;
    this.router.navigate(['login']);
  }

  contagemToken() {
    this.tokenExpirationTime = Date.now() + 30 * 60 * 1000;
    this.inactivitySubscription = interval(1000).subscribe(() => {
      const inactivityTime = Date.now();
      if (inactivityTime >= this.tokenExpirationTime) {
        this.logoutUser();
        if (this.inactivitySubscription) {
          this.inactivitySubscription.unsubscribe();
        }
      }
    });
  }
}
